


































































































































































































































































































































































































































































































































































































































































































































































































































































































// @ is an alias to /src
import { Component, Vue } from "vue-property-decorator";
import Navbar from "@/components/Navbar.vue";
import Footer from "@/components/Footer.vue";
import info from "@/info";
import Formulario from "@/components/Formulario.vue";
import Promotion from "@/components/Promotion.vue";
const UIkit = require("@/assets/uikit/js/uikit");

@Component({
  components: {
    Navbar,
    Footer,
    Formulario,
    Promotion,
  },
})
export default class Home extends Vue {
  public videoInfo: object = {};
  public homeInfo: Array<object> = [];
  public currentModel: string = "";
  public selectedModel: string = "";

  public clickedModel: string = "";
  public modalTitle: string = "";
  public origin: string = "";
  public interes: string = "";
  public aIndex: object = {};
  public rutaA: string = "../assets/images/";

  public engPercent: number = 55;
  public engTotal: number = 0;
  public engTotalFixed: string = "";
  public plazTotal: number = 72;
  public plazTotalIndex: number = 0;
  public mensTotal: number = 0;
  public mensTotalFixed: string = "";
  public mensMin: number = 1;
  public mensMinFixed: string = "";
  public mensMax: number = 10;
  public mensMaxFixed: string = "";
  public priceTotal: number = 0;
  public interesT: number = 0;
  public seguroAuto: number = 0;
  public seguroAutoFixed: string = "";
  public contadoIVA: number = 0;
  public constIVA: number = 0;
  public financiadoIVA: number = 0;
  public IVAF: number = 0;
  public IVAFixed: string = "";
  public ivaIndex: number = 0;
  public pagoIniT: number = 0;
  public pagoIniTFixed: string = "";
  public pagoMensT: number = 0; /*-- new --*/
  public pagoMensTFixed: string = ""; /*-- new --*/
  public autoName: string = "";

  public priceTotalCrudo: string = "";

  /* 2do cotizador sliders */

  navigateBasedOnResolution() {
    if (window.innerWidth <= 650) {
      this.$router.push({
        path: "/components/CotizadorMovil",
        query: { variableName: this.autoName },
      });
    } else {
      this.openMenuForm(
        this.autoName,
        "Cotízalo",
        "CTZ",
        this.aIndex,
        this.priceTotalCrudo
      ),
        this.scrollState("hidden");
    }
  }

  public rangesSliderEng() {
    const sliderEl = document.querySelector("#rangeSEng");
    const sliderEl2 = document.querySelector("#rangeSMens");

    sliderEl2!.addEventListener("input", (event2) => {
      let tempSliderValue2 = (event2.target as HTMLInputElement).value;
      this.mensTotal = Number(tempSliderValue2);

      const progress2 =
        ((Number(tempSliderValue2) -
          Number((sliderEl2 as HTMLInputElement).min)) /
          (Number((sliderEl2 as HTMLInputElement).max) -
            Number((sliderEl2 as HTMLInputElement).min))) *
        100;
      this.engPercent = Math.round(((100 - progress2) / 100) * (85 - 20) + 20);

      this.operationsForm();
    });

    sliderEl!.addEventListener("input", (event) => {
      let tempSliderValue = (event.target as HTMLInputElement).value;
      this.engPercent = Number(tempSliderValue);

      this.operationsForm();
    });
  }

  public setRadioP(value: string) {
    document.querySelectorAll(`input[name="pazos"]`).forEach((element) => {
      if ((element as HTMLInputElement).value === value) {
        (element as HTMLInputElement).checked = true;
      }
    });
  }

  public RadioP() {
    document.querySelectorAll(`input[name="pazos"]`).forEach((element) => {
      if ((element as HTMLInputElement).checked === true) {
        this.plazTotalIndex = Number((element as HTMLInputElement).value);
        this.plazTotal = 12 * (this.plazTotalIndex + 1);
        this.operationsForm();
      }
    });
  }

  public radioIVA() {
    document.querySelectorAll(`input[name="seguro"]`).forEach((element) => {
      console.log("test1");
      if ((element as HTMLInputElement).checked === true) {
        if ((element as HTMLInputElement).value === "0") {
          this.ivaIndex = 0;
        }
        if ((element as HTMLInputElement).value === "1") {
          this.ivaIndex = 1;
        }
        this.operationsForm();
      }
    });
  }

  public showModal(): void {
    UIkit.modal("#contactHomeModal").show();

    this.$modal.show(
      "contactHomeModal",
      {},
      {
        height: "auto",
        with: "auto",
        scrollable: false,
      }
    );
  }

  operationsForm(): void {
    this.engTotal = (this.engPercent / 100) * this.priceTotal;
    this.engTotalFixed = new Intl.NumberFormat("es-MX", {
      minimumFractionDigits: 2,
    }).format(this.engTotal);

    const interestRates = [6.87, 13.54, 20.52, 27.82, 35.43, 43.33];
    const interestCoefficients = [0.085, 0.17, 0.25, 0.35, 0.45, 0.54];

    this.interesT =
      interestRates[this.plazTotalIndex] -
      (this.engPercent - 20) * interestCoefficients[this.plazTotalIndex];

    this.mensMin =
      ((this.priceTotal *
        (interestRates[this.plazTotalIndex] -
          (20 - 20) * interestCoefficients[this.plazTotalIndex])) /
        100 +
        this.priceTotal -
        0.2 * this.priceTotal) /
      this.plazTotal;
    this.mensMinFixed = new Intl.NumberFormat("es-MX", {
      minimumFractionDigits: 2,
    }).format(this.mensMin);

    this.mensMax =
      ((this.priceTotal *
        (interestRates[this.plazTotalIndex] -
          (85 - 20) * interestCoefficients[this.plazTotalIndex])) /
        100 +
        this.priceTotal -
        0.85 * this.priceTotal) /
      this.plazTotal;
    this.mensMaxFixed = new Intl.NumberFormat("es-MX", {
      minimumFractionDigits: 2,
    }).format(this.mensMax);

    this.mensTotal =
      ((this.priceTotal * this.interesT) / 100 +
        this.priceTotal -
        this.engTotal) /
      this.plazTotal;
    this.mensTotalFixed = new Intl.NumberFormat("es-MX", {
      minimumFractionDigits: 2,
    }).format(this.mensTotal);

    if (this.ivaIndex === 0) {
      this.IVAF = this.contadoIVA - this.constIVA * (this.engPercent - 20);
      this.IVAFixed = new Intl.NumberFormat("es-MX", {
        minimumFractionDigits: 2,
      }).format(this.IVAF);
    }
    if (this.ivaIndex === 1) {
      this.IVAF =
        this.contadoIVA -
        this.constIVA * (this.engPercent - 20) +
        this.financiadoIVA;
      this.IVAFixed = new Intl.NumberFormat("es-MX", {
        minimumFractionDigits: 2,
      }).format(this.IVAF);
    }

    this.pagoIniT = this.engTotal + this.IVAF; /*-- ajustado --*/
    this.pagoMensT = this.mensTotal + this.IVAF / 12;
    if (this.ivaIndex === 0) {
      this.pagoIniT = this.pagoIniT + this.seguroAuto;
    }
    if (this.ivaIndex === 1) {
      this.pagoMensT = this.pagoMensT + this.seguroAuto / 12;
    }
    this.pagoMensTFixed = new Intl.NumberFormat("es-MX", {
      minimumFractionDigits: 2,
    }).format(this.pagoMensT);
    this.pagoIniTFixed = new Intl.NumberFormat("es-MX", {
      minimumFractionDigits: 2,
    }).format(this.pagoIniT); /*-- ajustado --*/

    const sliderEl2 = document.querySelector("#rangeSMens");

    (sliderEl2 as HTMLInputElement).min = String(this.mensMax);
    (sliderEl2 as HTMLInputElement).max = String(this.mensMin);
    (sliderEl2 as HTMLInputElement).value = String(this.mensTotal);
    const progress2 =
      ((this.mensTotal - Number((sliderEl2 as HTMLInputElement).min)) /
        (Number((sliderEl2 as HTMLInputElement).max) -
          Number((sliderEl2 as HTMLInputElement).min))) *
      100;
    (sliderEl2 as HTMLInputElement).style.background =
      `linear-gradient(to right, #017fff ${progress2}%, #ccc 0%)`;

    const sliderEl = document.querySelector("#rangeSEng");
    const progress =
      ((this.engPercent - Number((sliderEl as HTMLInputElement).min)) /
        (Number((sliderEl as HTMLInputElement).max) -
          Number((sliderEl as HTMLInputElement).min))) *
      100;
    (sliderEl as HTMLInputElement).style.background =
      `linear-gradient(to right, #017fff ${progress}%, #ccc 0%)`;
    (sliderEl as HTMLInputElement).value = String(this.engPercent);
  }

  addEng(): void {
    if (this.engPercent < 81) {
      this.engPercent = this.engPercent + 5;
      this.operationsForm();
    }
  }

  subtractEng(): void {
    if (this.engPercent > 24) {
      this.engPercent = this.engPercent - 5;
      this.operationsForm();
    }
  }

  addPlaz(): void {
    if (this.plazTotalIndex < 5) {
      this.plazTotalIndex = this.plazTotalIndex + 1;
      this.plazTotal = 12 * (this.plazTotalIndex + 1);
      this.operationsForm();
    }
  }

  subtractPlaz(): void {
    if (this.plazTotalIndex > 0) {
      this.plazTotalIndex = this.plazTotalIndex - 1;
      this.plazTotal = 12 * (this.plazTotalIndex + 1);
      this.operationsForm();
    }
  }

  addMens(): void {
    if (this.engPercent > 32) {
      this.engPercent = this.engPercent - 13;
      this.operationsForm();
    }
  }

  subtractMens(): void {
    if (this.engPercent < 73) {
      this.engPercent = this.engPercent + 13;
      this.operationsForm();
    }
  }

  scrollState(state: string) {
    const elem = document.getElementById("scrollBlock");
    elem!.style.overflow = state;
  }

  openMenuForm(
    auto: string,
    modalTitle: string,
    o: string,
    i: object,
    p: string
  ): void {
    this.selectedModel = this.currentModel;
    this.clickedModel = auto;
    this.modalTitle = modalTitle;
    this.origin = o;
    this.interes = o;
    this.aIndex = i;
    this.engPercent = 55;
    this.plazTotal = 72;
    this.plazTotalIndex = 5;
    this.priceTotal = parseFloat(p.replace(",", ""));
    this.engTotal = (this.engPercent / 100) * this.priceTotal;
    this.engTotalFixed = new Intl.NumberFormat("es-MX", {
      minimumFractionDigits: 2,
    }).format(this.engTotal);

    this.operationsForm();

    const idDivModel = document.getElementById("uk-navbar-dropdown-id-ml");
    const idDiv = document.getElementById("uk-navbar-dropdown-id");

    if (idDivModel) {
      idDivModel.style.display = "none";
    }
    if (idDiv) {
      idDiv.style.display = "none";
    }

    let curtainForm = document.getElementById("curtain-formH");
    let menuForm = document.getElementById("menu-formH");

    if (curtainForm) {
      curtainForm.style.display = "block";
    }
    menuForm?.classList.remove("disable-menu-formH");
    menuForm?.classList.add("open-menu-formH");
  }
  closeMenuForm() {
    let curtainForm = document.getElementById("curtain-formH");
    let menuForm = document.getElementById("menu-formH");

    if (curtainForm) {
      curtainForm.style.display = "none";
    }
    menuForm?.classList.remove("open-menu-formH");
    menuForm?.classList.add("disable-menu-formH");
  }

  openMenuForm2(
    auto: string,
    i: object,
    sA: number,
    IVA: number,
    constIVA: number,
    fIVA: number
  ): void {
    this.closeMenuForm();

    this.selectedModel = this.currentModel;
    this.clickedModel = auto;
    this.aIndex = i;
    this.seguroAuto = sA;
    this.seguroAutoFixed = new Intl.NumberFormat("es-MX", {
      minimumFractionDigits: 2,
    }).format(this.seguroAuto);
    this.contadoIVA = IVA;
    this.constIVA = constIVA;
    this.financiadoIVA = fIVA;

    const idDivModel = document.getElementById("uk-navbar-dropdown-id-ml");
    const idDiv = document.getElementById("uk-navbar-dropdown-id");

    if (idDivModel) {
      idDivModel.style.display = "none";
    }
    if (idDiv) {
      idDiv.style.display = "none";
    }

    let curtainForm = document.getElementById("curtain-formH2");
    let menuForm = document.getElementById("menu-formH2");

    if (curtainForm) {
      curtainForm.style.display = "block";
    }
    menuForm?.classList.remove("disable-menu-formH2");
    menuForm?.classList.add("open-menu-formH2");

    this.IVAF = this.contadoIVA - this.constIVA * (this.engPercent - 20);
    this.IVAFixed = new Intl.NumberFormat("es-MX", {
      minimumFractionDigits: 2,
    }).format(this.IVAF);

    const sliderEl2 = document.querySelector("#rangeSMens");

    (sliderEl2 as HTMLInputElement).min = String(this.mensMax);
    (sliderEl2 as HTMLInputElement).max = String(this.mensMin);

    this.rangesSliderEng();
    this.setRadioP(String(this.plazTotalIndex));
    this.operationsForm();
  }
  closeMenuForm2() {
    let curtainForm = document.getElementById("curtain-formH2");
    let menuForm = document.getElementById("menu-formH2");

    if (curtainForm) {
      curtainForm.style.display = "none";
    }
    menuForm?.classList.remove("open-menu-formH2");
    menuForm?.classList.add("disable-menu-formH2");
  }

  openMenuForm21(): void {
    this.closeMenuForm2();

    let curtainForm = document.getElementById("curtain-formH2-1");
    let menuForm = document.getElementById("menu-formH2-1");

    if (curtainForm) {
      curtainForm.style.display = "block";
    }
    menuForm?.classList.remove("disable-menu-formH2-1");
    menuForm?.classList.add("open-menu-formH2-1");
  }
  closeMenuForm21() {
    let curtainForm = document.getElementById("curtain-formH2-1");
    let menuForm = document.getElementById("menu-formH2-1");

    if (curtainForm) {
      curtainForm.style.display = "none";
    }
    menuForm?.classList.remove("open-menu-formH2-1");
    menuForm?.classList.add("disable-menu-formH2-1");
  }

  openMenuFormF(): void {
    const idDivModel = document.getElementById("uk-navbar-dropdown-id-ml");
    const idDiv = document.getElementById("uk-navbar-dropdown-id");

    if (idDivModel) {
      idDivModel.style.display = "none";
    }
    if (idDiv) {
      idDiv.style.display = "none";
    }

    let curtainForm = document.getElementById("curtain-formHF");
    let menuForm = document.getElementById("menu-formHF");

    if (curtainForm) {
      curtainForm.style.display = "block";
    }
    menuForm?.classList.remove("disable-menu-formHF");
    menuForm?.classList.add("open-menu-formHF");
  }
  closeMenuFormF() {
    let curtainForm = document.getElementById("curtain-formHF");
    let menuForm = document.getElementById("menu-formHF");

    if (curtainForm) {
      curtainForm.style.display = "none";
    }
    menuForm?.classList.remove("open-menu-formHF");
    menuForm?.classList.add("disable-menu-formHF");
  }

  mounted() {
    this.homeInfo = info.home.headerSlider;
  }

  public changeSlider(i: any): void {
    this.currentModel = i.target.dataset.name;
    this.videoInfo = info.home.headerVideo[this.currentModel];
    this.$router.push({ query: { variableNavName: this.currentModel } });
  }
}
